export default [
    {
        path: '/distributors',
        name: 'distributors',
        meta: {
            isSection: true
        },
        component: () => import('@/views/distributor-list/index.vue'),
        props: { type: 'distributors' }
    },
    // {
    //     path: '/distributors/add',
    //     name: 'distributors_add',
    //     component: () => import('@/views/distributor-details/index.vue')
    // },
    {
        path: '/distributors/:uuid',
        component: () => import('@/components/yuri-submenu/index.vue'),
        children: [
            {
                path: '',
                name: 'distributors_uuid',
                component: () => import('@/views/distributor-details/index.vue'),
                props: route => ({ id: route.params.uuid, type: route.params.type })
            },
            {
                path: 'edit',
                name: 'distributors_uuid_edit',
                component: () => import('@/views/distributor-details/index.vue')
            },
            {
                path: 'view',
                name: 'distributors_uuid_view',
                component: () => import('@/components/dynamic-view/index.vue'),
                props: route => ({ view: route.query.view, id: route.query.id, type: route.params.type }),
                meta: {
                    isView: true
                }
            }
        ]
    }
];
